import React from "react";
import BalanceSheetPage from "../../../../entities/DashboardPage/AccountingModule/BalanceSheet";
// import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
// import AuthService from "../../../../../api/AuthService";
// import AuthService from "../../../api/AuthService";
// eslint-disable-next-line import/default
// import LoaderHelper from "../../../utils/Loader/LoaderHelper";

const BalanceSheet = () => {

  return (
    
    <BalanceSheetPage/>
  )


}

export default BalanceSheet;
